import type { HubIconName } from "./CommandCenterHub.types";

// Final Hub Center — outlined neon icon set (visual authority).
// Pure SVG stroke icons, no fill, no emoji (the CommandCenter tree is under a
// hard no-emoji audit). Every navigable option is one of these glowing icons.

const paths: Record<HubIconName, React.ReactNode> = {
  divisions: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </>
  ),
  projects: <path d="M12 4l8 4-8 4-8-4 8-4zM4 12l8 4 8-4M4 16l8 4 8-4" />,
  notifications: (
    <>
      <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 9h16M8 3v4M16 3v4" />
    </>
  ),
  strategy: <path d="M12 4l8 15H4z" />,
  operations: (
    <>
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="2.4" />
    </>
  ),
  finance: (
    <>
      <path d="M4 16l5-5 3 3 6-7" />
      <path d="M15 7h4v4" />
    </>
  ),
  advisory: <rect x="5" y="5" width="14" height="14" rx="2" />,
  comms: <path d="M5 5h14v10H9l-4 4z" />,
  capital: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 7v10M9.5 9.2h5M9.5 14h5" />
    </>
  ),
  creative: <path d="M12 4l2.3 5 5.5.5-4.1 3.6 1.2 5.4L12 20.9 7.1 18.5l1.2-5.4L4.2 9.5 9.7 9z" />,
  olivium: <path d="M12 3l7.5 4.5v9L12 21l-7.5-4.5v-9z" />,
  engineering: <path d="M6 20V10M12 20V4M18 20v-7" />,
  vault: <path d="M12 20s-7-4.6-7-9.4A3.6 3.6 0 0 1 12 8a3.6 3.6 0 0 1 7 2.6C19 15.4 12 20 12 20z" />,
  video: (
    <>
      <rect x="3" y="7" width="12" height="10" rx="2" />
      <path d="M15 10.5l6-3v9l-6-3z" />
    </>
  ),
  camera: (
    <>
      <path d="M3 9a2 2 0 0 1 2-2h1.5L8 4.8h8L17.5 7H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <circle cx="12" cy="13" r="3.4" />
    </>
  ),
  files: <path d="M4 7a2 2 0 0 1 2-2h3.5l2 2H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />,
  photo: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="8.5" cy="9" r="1.9" />
      <path d="M4.5 18l5-5 3.2 3.2L16 13l3.5 3.5" />
    </>
  ),
  code: <path d="M8.5 8l-4 4 4 4M15.5 8l4 4-4 4" />,
  other: (
    <>
      <circle cx="6" cy="12" r="1.7" />
      <circle cx="12" cy="12" r="1.7" />
      <circle cx="18" cy="12" r="1.7" />
    </>
  ),
  terminal: <path d="M6 8l4 4-4 4M13 16h5" />,
};

export function CommandCenterIcon({ name, className }: { name: HubIconName; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}
